import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { forgotPassword } from "../../redux/actions/userActionCreators"


const ForgotPassword = () => {


  const { t } = useTranslation()


  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("valid_email"))
        .max(255)
        .required(t("required_field")),
    }),
    onSubmit: (values) => {
      dispatch(forgotPassword(values.email));
    },
  });

  return (
    < >
      <Box
      >
        <h1 >{t("forgot_password")}</h1>
      </Box>
      <br></br>
      <Box
        component="main"
      >
        <form onSubmit={formik.handleSubmit}>
          <div style={{ height: "130px" }}>
            <Typography variant="subtitle2">{t("email_address")}</Typography>
            <TextField
              error={Boolean(
                formik.touched.email && formik.errors.email
              )}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              margin="normal"
              name="email"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.email}
              placeholder={t("type_email")}
            />
          </div>
          <Box sx={{ py: 2 }}>
            <Button
              color="secondary"
              disabled={formik.isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              {t("send_email")}
            </Button>
          </Box>
        </form>

      </Box>
    </>
  );
};

export default ForgotPassword;